var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRugbyUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Rugby_Union") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 42 0 42 42 0 42"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(25.000000, 25.000000) scale(1, -1) translate(-25.000000, -25.000000) translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3308352,37.3140723 C23.2025933,32.0572281 31.7206211,23.9065831 37.3838833,12.2513502 C39.6828681,23.923417 26.8573753,40.0520025 12.3308352,37.3140723 M4.26121626,29.1697621 C3.13910926,15.4800353 16.050883,3.82692232 29.5247951,4.52826393 C19.1667368,10.0968239 10.9939592,18.649739 4.26121626,29.1697621 M32.3669464,5.95886547e-05 C13.1792649,-0.0272639021 1.68646029,9.34071563 0.0506281961,30.7493392 C-0.349367452,37.0044765 1.62750161,40.5279931 5.74335718,41.5958172 C6.26757727,41.7306139 6.80443677,41.8106439 7.34127105,41.8569558 C22.2152057,43.1016485 36.520695,36.2273449 40.6049899,21.0780734 C41.6597372,17.164931 41.6828968,13.1527795 41.9629064,9.14062796 C42.4281678,2.45164768 38.4765236,0.153869954 32.3669464,5.95886547e-05",
    id: "Fill-1",
    fill: "currentColor",
    mask: "url(#mask-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugbyUnion);
export default ForwardRef;